import React, { useEffect } from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";

const Cgu = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <StyledCgu>
      <h1>CONDITIONS GÉNÉRALES D'UTILISATION - CGU</h1>

      <section className="first-box">
        <p className="info-important">
          *Les annonces avec numéro autre que Guyane Française sont refusées.
          Numéro attendu pour chaque annonce : +594 694 xxx xxx
        </p>
        <h2>1. Objet des CGU</h2>
        <p>
          Les présentes Conditions Générales d’Utilisation (CGU) définissent les
          modalités d’utilisation du site www.emohup.fr , un site d’annonces
          pour particuliers et professionnels basé en Guyane Française. Le terme
          « Annonces » désigne les petites annonces, les évènements et les
          annonces business (AB) publiés sur le site.
        </p>
        <p className="info-important">
          *Le terme "Annonces" présenté dans ce présent CGU peut faire référence
          aux petites annonces, aux évènements et aux annonces business.
        </p>
      </section>

      <section className="first-box">
        <h2>2. Publication des annonces</h2>
        <p>
          La publication d’une annonce sur Emohup.fr est gratuite. Les
          utilisateurs ne sont pas obligés de s’inscrire, et aucune donnée
          sensible ou confidentielle n’est requise. Chaque annonce doit être
          validée par un administrateur avant sa mise en ligne.
        </p>
        <p>
          Les annonces peuvent être refusées sans explication si elles
          comportent des contenus susceptibles de porter atteinte à autrui ou au
          site. Les annonces de vente d’armes ou d’animaux sont automatiquement
          supprimées. Les annonces jugées commerciales et non conformes au
          formulaire ou suspectes peuvent être rejetées.
        </p>
        <strong>Chaque annonce a une durée de validité :</strong>
        <p>Petites annonces : 45 jours</p>
        <p>Petites annonces : 45 jours</p>
        <p>
          En publiant une annonce, l’utilisateur accepte que son contenu puisse
          être utilisé pour la promotion du site www.emohup.fr (hors coordonnées
          personnelles telles que téléphone et email).
        </p>
        <p className="info-important">
          *Afin que les AB(Annonces Business) soient reconnues comme actives par
          l'annonceur, elles sont programmées afin d'etre supprimées apres 30
          jours
        </p>
      </section>

      <section className="first-box">
        <h2>3. Contenus publiés par les utilisateurs</h2>
        <p>
          Les utilisateurs conservent la propriété des contenus (textes, images,
          vidéos) qu’ils publient sur Emohup.fr. En publiant une annonce,
          l’utilisateur accorde à Emohup.fr une licence gratuite, non-exclusive
          et mondiale pour reproduire, afficher et distribuer le contenu sur le
          site, uniquement dans le cadre des services proposés.
        </p>
        <p>
          L’utilisateur garantit que les contenus respectent la législation en
          vigueur et les droits de tiers. Emohup.fr se réserve le droit de
          retirer toute annonce ou contenu ne respectant pas ces règles.
        </p>
      </section>

      <section className="first-box">
        <h2>4. Sécurité et prévention des fraudes</h2>
        <p>
          Bien que nous fassions notre possible pour proposer des annonces
          vérifiées, les utilisateurs doivent rester vigilants face aux arnaques
          et tentatives de phishing. Aucun virement ne doit être effectué sans
          avoir rencontré physiquement le vendeur ou interlocuteur. En cas de
          doute, contactez Emohup.fr pour signaler l’annonce suspecte.
        </p>
        <h2>5. Publicité et contenus sponsorisés</h2>
        <p>
          Certaines parties du site peuvent afficher des annonces
          promotionnelles ou du contenu sponsorisé, y compris des liens affiliés
          vers Loryum. Ces contenus sont ajoutés par l’équipe et ne proviennent
          pas de tiers publicitaires. Emohup.fr ne peut être tenu responsable du
          contenu des sites externes accessibles via ces liens.
        </p>
      </section>

      <section className="first-box">
        <h2>6. Données personnelles</h2>
        <p>
          La collecte et le traitement des données personnelles sont conformes
          au RGPD et à la loi Informatique et Libertés. Aucune donnée sensible,
          comme des coordonnées bancaires, n’est demandée. Les utilisateurs
          disposent d’un droit d’accès, de rectification et de suppression de
          leurs données en contactant :<strong>dev.frenchlod@gmail.com</strong>.
        </p>
        <p>EmohUp n'utilise aucune donnée a fin des commerciaux</p>
      </section>
      <section className="first-box">
        <h2>7. Cookies </h2>
        <p>
          Des cookies sont utilisés pour améliorer l’expérience utilisateur,
          analyser le trafic et suivre les liens affiliés. Les cookies
          strictement nécessaires au fonctionnement du site ne peuvent être
          refusés et ne stockent aucune donnée personnelle identifiable.
        </p>
      </section>

      <section className="first-box">
        <h2>8. Liens hypertextes et affiliation</h2>
        <p>
          Les liens vers des sites externes, y compris Loryum dans le cadre d’un
          programme d’affiliation, sont sous la responsabilité des utilisateurs
          qui les consultent. Certains liens permettent à Emohup.fr de percevoir
          une commission.
        </p>
        <p>
          Les utilisateurs ne peuvent pas inclure de lien hypertexte dans leurs
          annonces sans autorisation sous peine de rejet.
        </p>
      </section>
      <section className="first-box">
        <h2>9. Modifications des CGU</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation peuvent être
          modifiées à tout moment par EmohUp, sans préavis. Les utilisateurs
          sont invités à consulter régulièrement les CGU afin de se tenir
          informés des éventuels changements. Toute modification prendra effet
          dès sa publication sur le site www.emohup.fr.
        </p>
      </section>

      <section className="first-box">
        <h2>10. Droit applicable et juridiction compétente</h2>
        <p>
          Le site est régi par le droit français. Tout litige relève des
          tribunaux français, situés au siège de l’éditeur.
        </p>
      </section>
      <section className="first-box">
        <h2>11. Contact</h2>
        <p>
          Pour toute question ou réclamation concernant les CGU ou les annonces
          : dev.frenchlod@gmail.com
        </p>
      </section>
    </StyledCgu>
  );
};

export default Cgu;
const StyledCgu = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  h1 {
    font-size: 2.5em;
    letter-spacing: 0.4em;
    text-align: center;
  }
  .first-box {
    margin: 10px 0px;
    strong {
      font-size: 1.3em;
      padding: 5px;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
      margin: 0px 10px;
    }
    p {
      margin: 20px 0px;
      font-size: 1.1em;
      strong {
        color: ${COLORS.orange};
      }
    }
    h2 {
      margin: 15px 0px;
      font-size: 1.8em;
    }
    .info-important {
      margin: 20px auto;
      background: ${COLORS.blueLow};
      width: 50%;
      padding: 10px;
      color: ${COLORS.danger};
      text-align: center;
      font-family: Arial, Helvetica, sans-serif;
    }
  }
  //width =< 429px
  @media screen and (max-width: 429px) {
    h1 {
      font-size: 1.7em;
      font-weight: normal;
      letter-spacing: 0.2em;
    }
    .first-box {
      .info-important {
        width: 100%;
      }
    }
  }
`;
